import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface SalesManagerRouteProps {
  children: React.ReactNode;
}

export const SalesManagerRoute: React.FC<SalesManagerRouteProps> = ({ children }) => {
  const { user } = useAuth();

  // If user is sales_manager, redirect to sales intelligence
  if (user?.role === 'sales_manager') {
    return <Navigate to="/sales-intelligence" replace />;
  }

  return <>{children}</>;
};

